export default __webpack_public_path__ + "static/media/kd.abf474c3.jpg";